import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import WarningIcon from '@material-ui/icons/Warning';
import useWindowDimensions from '../views/Login'

const useStyles = makeStyles((theme) => ({
  father: {
    marginTop: '5vh',
    borderRadius: '10px',
    border: '1px solid #CCCCCC',
    width: '80vw',
  },
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  preDivs: {
    display: 'flex',
    margin: '20px',
    alignItems: 'center',
    height: '3vh',
  },
  preDivs2: {
    display: 'flex',
    margin: '20px',
    alignItems: 'center',
    height: '5vh',
  },
  iconColor: {
    color: 'rgba(0, 0, 0, 0.5)'
  },
  textOrder: {
    color: '#58595B',
    fontSize: '20px',
    fontWeight: 'bold'
  },
  textOrder2: {
    color: '#58595B',
    fontSize: '18px',
    fontWeight: 'bold'
  },
  textGrayClear: {
    marginLeft: '5px',
    color: '#9D9D9C',
    fontSize: '16px',
  },
  textGrayClear2: {
    marginLeft: '5px',
    color: '#9D9D9C',
    fontSize: '14px',
  },
}));

export const CardNotFound = (elem) => {
  const { width } = useWindowDimensions();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Card className={classes.father}>
        <CardContent>
          <div className={classes.preDivs}>
            <div className={[(width > 450) ? classes.textOrder : classes.textOrder2]}>{elem.id}</div>

          </div>
          <div className={classes.preDivs2}>
            <WarningIcon className={classes.iconColor} />
            <div className={[(width > 450) ? classes.textGrayClear : classes.textGrayClear2]}>No encontramos el pedido que buscaste. Comprueba que el número de seguimiento sea correcto </div>
          </div>

        </CardContent>
      </Card>
    </div>
  );
};

